import Page from '../page';
import TireWarrantyForm from '../../components/tire-warranty/tire-warranty-form';

export default class TireWarrantyDetailPage extends Page {
  private readonly form: TireWarrantyForm;

  constructor(body: JQuery) {
    super();
    this.form = new TireWarrantyForm(body.find('.js-warrantyForm'));
  }
}
